import { render, staticRenderFns } from "./TipoNotaEntrada.vue?vue&type=template&id=4634f2a5&"
import script from "./TipoNotaEntrada.vue?vue&type=script&lang=js&"
export * from "./TipoNotaEntrada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports